import { Box, Grid, Paper, TextField, Typography } from "@mui/material";
import React from "react";

const Profile = () => {
  return (
    <Box sx={{ padding: 4 }}>
      <Paper elevation={3} sx={{ padding: 4, maxWidth: 800, margin: "auto" }}>
        <Typography variant="h4" align="center" gutterBottom>
          Profile
        </Typography>
        <Grid container spacing={2}>
          {/* First Name */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="First Name"
              variant="outlined"
              fullWidth
              value="John"
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          {/* Last Name */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Last Name"
              variant="outlined"
              fullWidth
              value="Doe"
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          {/* Email */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Email"
              variant="outlined"
              fullWidth
              value="johndoe@example.com"
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          {/* Address */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Address"
              variant="outlined"
              fullWidth
              multiline
              rows={2}
              value="123 Main Street, Springfield, USA"
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default Profile;
